<template>
    <VinQuery 
      class="recall-query-page"
      :main-title="mainTitle"
      :sub-title="subTitle"
      :remark="remark"
      :form="form"
      :loading="loading"
      :init="init"
      :query-method="handleQuery"
    >
      <!-- 成功结果 - 在召回范围内 -->
      <template #SuccessContent v-if="successObj && Object.prototype.toString.call(successObj) === '[object Object]' && Object.keys(successObj).length > 0">
        <SuccessContent
          :main-title="successObj?.title"
          :hints="[successObj?.content,successObj?.content_one]"          button-text="确认"
          :confirm-method="handleSuccessConfirm"
       >
          <template #icon>
            <div class="default-icon">
              <svg viewBox="0 0 76 76" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="76.000000" height="76.000000" fill="none" customFrame="#000000">
                <g id="提交成功">
                  <path id="矢量 29" d="M76 38C76 58.9846 58.9846 76 38 76C17.012 76 0 58.9846 0 38C0 17.012 17.0154 0 38 0C58.9846 0 76 17.0154 76 38Z" fill="rgb(248,177,33)" fill-opacity="0.100000001" fill-rule="nonzero" />
                  <path id="矢量 47" d="M35.5417 43.6499C35.6258 44.1086 35.8365 44.5347 36.1499 44.88C36.4634 45.2253 36.8671 45.476 37.3156 45.604C37.764 45.7319 38.2393 45.7319 38.6878 45.604C39.1363 45.476 39.54 45.2253 39.8535 44.88C40.1669 44.5347 40.3776 44.1086 40.4617 43.6499L42.1017 21.1C42.1002 20.3807 41.9099 19.6745 41.5498 19.0518C41.1897 18.4292 40.6725 17.9119 40.0499 17.5519C39.4272 17.1918 38.721 17.0015 38.0017 17C37.2403 17.0188 36.4982 17.2435 35.8544 17.6504C35.2105 18.0572 34.6889 18.631 34.3451 19.3106C34.0013 19.9902 33.848 20.7502 33.9017 21.51L35.5417 43.6499ZM38.0017 49.7999C37.1908 49.7999 36.3981 50.0404 35.7239 50.4909C35.0496 50.9414 34.5241 51.5817 34.2138 52.3309C33.9035 53.0801 33.8223 53.9044 33.9805 54.6998C34.1387 55.4951 34.5292 56.2256 35.1026 56.799C35.676 57.3724 36.4065 57.7629 37.2018 57.9211C37.9972 58.0793 38.8215 57.9981 39.5707 57.6878C40.3199 57.3775 40.9602 56.852 41.4107 56.1777C41.8612 55.5035 42.1017 54.7108 42.1017 53.8999C42.1459 53.1684 41.9817 52.4393 41.6281 51.7974C41.2745 51.1555 40.7461 50.6271 40.1042 50.2735C39.4623 49.9199 38.7332 49.7557 38.0017 49.7999Z" fill="rgb(248,177,33)" fill-rule="nonzero" />
                </g>
              </svg>
            </div>
          </template>
      </SuccessContent>
      </template>

      <!-- 失败结果 - 不在召回范围内 -->
      <template #FailContent v-if="failObj && Object.prototype.toString.call(failObj) === '[object Object]' && !failObj.has_recall">
        <FailContent
          :main-title="failObj?.title"
          :hints="[failObj?.content]"
          button-text="确认"
          :confirm-method="handleFailConfirm"
       >
          <template #icon>
            <div class="default-icon">
              <svg viewBox="0 0 76 76" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="76.000000" height="76.000000" fill="none" customFrame="#000000">
                <g id="提交成功">
                  <path id="矢量 29" d="M76 38C76 58.9846 58.9846 76 38 76C17.012 76 0 58.9846 0 38C0 17.012 17.0154 0 38 0C58.9846 0 76 17.0154 76 38Z" fill="rgb(22,189,51)" fill-opacity="0.100000001" fill-rule="nonzero" />
                  <path id="矢量 30" d="M49.9147 26.555C50.2867 26.1765 50.7544 25.9022 51.2698 25.7601C51.7853 25.618 52.3299 25.6134 52.8478 25.7466C53.3657 25.8799 53.8382 26.1462 54.2167 26.5182C54.5953 26.8903 54.8662 27.3547 55.0018 27.8637C55.1374 28.3727 55.1326 28.908 54.9881 29.4146C54.8436 29.9212 54.5644 30.3809 54.1794 30.7465L36.0834 48.5321C35.7091 48.8999 35.2429 49.1644 34.7316 49.2991C34.2203 49.4337 33.682 49.4337 33.1707 49.2991C32.6594 49.1644 32.1932 48.8999 31.8188 48.5321L22.7709 39.6393C22.3858 39.2738 22.1067 38.8141 21.9621 38.3074C21.8176 37.8008 21.8128 37.2655 21.9484 36.7565C22.084 36.2475 22.3549 35.7831 22.7335 35.411C23.112 35.039 23.5845 34.7727 24.1024 34.6394C24.6203 34.5062 25.1649 34.5108 25.6804 34.6529C26.1959 34.795 26.6636 35.0693 27.0355 35.4478L33.9511 42.2449L49.9147 26.555Z" fill="rgb(22,189,51)" fill-rule="nonzero" />
                </g>
              </svg>

            </div>
          </template>
        </FailContent>
      </template>
    </VinQuery>
</template>
<script>
import VinQuery from '../pc/message/message-elements/vin-query/index.vue'
import SuccessContent from '../pc/message/message-elements/vin-query/success-content.vue'
import FailContent from '../pc/message/message-elements/vin-query/fail-content.vue'
import { VIN_ERROR_CODE } from '../pc/message/message-elements/vin-query/constant'
import sessionAPI from '@/api/session'
/**
 * 召回查询卡片流程：
 * 1. 初始状态：用户输入车架号查询
 * 2. 在召回范围状态：显示召回信息，用户点击确认后返回初始状态
 * 3. 不在召回范围状态：显示提示，用户点击确认后返回初始状态
*/

/*
 * OTA升级查询组件
 * 签名机制说明（车架号关联版）：
 * 1. 每次查询前根据当前车架号获取签名串（不再预加载）
 * 2. 查询OTA时携带签名串
 * 3. 签名过期(40015)时自动重新获取并重试（最多3次）
 * 4. 每次查询使用独立签名，避免车架号串号问题
 */
export default {
      components: { VinQuery, SuccessContent, FailContent },
      data() {
        return {
             mainTitle:'车辆召回范围查询',
             subTitle:'输入17位车架号，快速查询是否在召回范围内',
             remark:'温馨提示：召回数据每日更新同步，查询有疑问可联系线下授权服务门店检修',
             form: {
               formTitle: '车辆车架号（VIN）',
               placeholder: '请输入17位车辆识别代码',
               hint: '车架号位于行驶证/车辆前挡风玻璃左下角',
               buttonText: '立即查询召回范围',
               showHintPrefix:true
             },
             vinValue: '',
            // 在召回范围内
            successObj:{},
            // 不在召回范围内
            failObj:undefined,
            loading:false,
            // 当用户点击确认按钮回到初始值
            init:true,
            // 最大重试次数
            maxRetryCount: 3,
        }
      },
      methods: {
        /**
         * 获取OTA加密签名串（需要传车架号）
         * @param {string} vin - 车架号
         */
        async fetchEncryptData(vin) {
          try{
            console.log(`获取召回加密签名串, 车架号: ${vin}`)
            const res=await sessionAPI.getVinEncryptStr({param:vin})
            console.log('获取召回加密签名串,res: ',res)
            return res?.data?.encryptData
          }catch(error) {
            console.error('获取召回加密签名串失败:', error)
            this.encryptData = null
          }
        },
        /**
         * OTA查询主方法（支持自动重试）
         * @param {string} vinValue - 车架号
         * @param {number} retryCount - 当前重试次数（内部使用）
         */
        async handleQuery(vinValue, retryCount = 0) {
          console.log('外层函数接收到的查询车架号:', vinValue, '重试次数:', retryCount)
          this.vinValue = vinValue
          this.loading = true
          this.successObj=undefined
          this.failObj = undefined

          try {
             const encryptData = await this.fetchEncryptData(vinValue)
            if (!encryptData) {
              throw new Error('获取签名串失败')
            }
             // 携带 encryptData 调用接口
            const res = await sessionAPI.queryVINRecallWithVIN({ vin: vinValue, encryptData })
            console.log('召回查询结果:', res)
            if(res?.code===VIN_ERROR_CODE.EXPIRED_SIGN) {
              if (retryCount < this.maxRetryCount) {
                console.log(`签名过期(40015)，第${retryCount + 1}次重试...`)
                return this.handleQuery(vinValue, retryCount + 1)
              } else {
                throw new Error('签名串获取失败，重试次数已达上限')
              }
            }
            // 处理正常业务逻辑
            const keys = Object.prototype.toString.call(res) === '[object Object]'?Object.keys(res):[]
            // 根据接口返回的 has_recall 字段判断
            if (keys.includes('has_recall') && res.has_recall) {
              this.successObj = res
              this.init = false
              // 当无召回信息就给failObj赋值
            } else if (keys.includes('has_recall') && !res.has_recall) {
              this.failObj = res
              this.init = false
            } else {
              throw new Error('查询结果格式异常')
            }
          } catch (error) {
            // 其他错误，默认视为不在召回范围
            this.failObj = { has_recall: false, title: '车辆不在本次召回范围', content: '请持续关注官方召回通知' }
            this.init = false
          } finally {
            this.loading = false
          }
        },
        handleSuccessConfirm() {
          // 确认召回信息
          console.log('确认召回信息')
          this.init = true
          this.successObj = undefined
        },
        handleFailConfirm() {
          // 确认不在召回范围
          console.log('确认不在召回范围')
          this.init = true
          this.failObj = undefined
        }
      }
}
</script>
<style lang="less" scoped>
@import '../pc/message/message-elements/vin-query/common.less';

.default-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.recall-query-page {
  background-image: url('~@/assets/image/recall_query.png');
     :deep(.remark){
    // form-wrapper和上面副标题的距离：138 - 66 - 48=24px
    // 24px+16px+form-wrapper的高度：24px+16px+202px=242px
    .px2rem(margin-top, 242);
  }
}
</style>